"use client";

import { Mail, Facebook, Instagram, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
function FooterNavConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col items-center gap-3 md:items-start">
        <div className="h-4 w-24 bg-primary/10 animate-pulse rounded-md" />
        <div className="h-4 w-32 bg-primary/10 animate-pulse rounded-md" />
        <div className="h-4 w-28 bg-primary/10 animate-pulse rounded-md" />
        <div className="h-4 w-20 bg-primary/10 animate-pulse rounded-md" />
      </div>;
  }
  return <nav className="flex flex-col items-center gap-3 md:items-start">
      {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="font-default text-sm tracking-wide text-muted-foreground transition-colors duration-300 hover:text-secondary">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  const socials = [{
    id: "instagram",
    label: "Instagram",
    href: "#"
  }, {
    id: "facebook",
    label: "Facebook",
    href: "#"
  }, {
    id: "twitter",
    label: "Twitter",
    href: "#"
  }];
  return <section data-section-id="2013" id="footer" className="dark bg-background text-foreground">
      <div className="mx-auto max-w-6xl px-6 py-20 md:px-8 md:py-24">
        <div className="grid grid-cols-1 gap-14 text-center md:grid-cols-3 md:gap-10 md:text-left">
          {}
          <div className="flex flex-col items-center gap-6 md:items-start">
            <Link to="/" className="inline-flex">
              <WvcLogo className="h-7 w-auto" />
            </Link>
            <p className="font-serif text-lg italic leading-relaxed text-muted-foreground max-w-xs">
              "Lighting the way for every family, ensuring no one walks the path of neurodiversity alone."
            </p>
          </div>

          {}
          <div className="flex flex-col items-center gap-5 md:items-start">
            <h3 className="font-default text-sm font-semibold uppercase tracking-widest text-secondary">
              Navigate
            </h3>
            <MenuProvider menu_id="34">
              <FooterNavConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col items-center gap-5 md:items-start">
            <h3 className="font-default text-sm font-semibold uppercase tracking-widest text-secondary">
              Get In Touch
            </h3>
            <Link to="mailto:hello@hopetorchlighters.org" className="inline-flex items-center gap-2 font-default text-sm tracking-wide text-muted-foreground transition-colors duration-300 hover:text-secondary">
              <Mail className="size-4" aria-hidden="true" />
              hello@hopetorchlighters.org
            </Link>
            <div className="flex items-center gap-5 pt-1">
              {socials.map((social, i) => <Link key={social.id} data-index={i} to={social.href} aria-label={social.label} className="text-muted-foreground transition-colors duration-300 hover:text-secondary">
                  {social.id === "instagram" && <Instagram className="size-5" strokeWidth={1.25} aria-hidden="true" />}
                  {social.id === "facebook" && <Facebook className="size-5" strokeWidth={1.25} aria-hidden="true" />}
                  {social.id === "twitter" && <Twitter className="size-5" strokeWidth={1.25} aria-hidden="true" />}
                </Link>)}
            </div>
          </div>
        </div>

        {}
        <div className="mt-16 h-px w-full bg-border" />

        {}
        <div className="mt-8 flex flex-col items-center justify-between gap-4 text-center md:flex-row md:text-left">
          <p className="font-default text-xs tracking-wide text-muted-foreground">
            &copy; {new Date().getFullYear()} Hope Torchlighters. All rights reserved.
          </p>
          <Link to="#" className="font-default text-xs tracking-wide text-muted-foreground transition-colors duration-300 hover:text-secondary">
            Privacy &amp; Community Guidelines
          </Link>
        </div>
      </div>
    </section>;
}